import React from 'react';
import PropTypes from 'prop-types';
import './ActionBar.css';

/**
 * The one layout for a group of actions: page headers, panels and dialog
 * footers. From md up the secondary actions sit on the left and the primary
 * on the right. On a phone every button is full width and 44 px tall, the
 * primary first. `stickyPrimaryOnPhone` pins the primary to the bottom of the
 * screen on a phone, so it stays in view on a long page; it is the same
 * element at every width, so nothing remounts when the width changes.
 */
function ActionBar({
    primary = null,
    secondary = null,
    stickyPrimaryOnPhone = false,
    className = '',
    label,
}) {
    const secondaries = React.Children.toArray(secondary).filter(Boolean);
    if (!primary && secondaries.length === 0) return null;
    return (
        <div
            className={`action-bar ${className}`.trim()}
            role={label ? 'group' : undefined}
            aria-label={label}
        >
            {secondaries.length > 0 && (
                <div className="action-bar-secondary">{secondaries}</div>
            )}
            {primary && (
                <div
                    className={`action-bar-primary${stickyPrimaryOnPhone ? ' psh-sticky-primary' : ''}`}
                >
                    {primary}
                </div>
            )}
        </div>
    );
}

ActionBar.propTypes = {
    primary: PropTypes.node,
    secondary: PropTypes.node,
    stickyPrimaryOnPhone: PropTypes.bool,
    className: PropTypes.string,
    label: PropTypes.string,
};

export default ActionBar;
